<template>
  <bvue-ui-view :scroll="true">
	<div class="w-full">
      <button @click="$router.go(-1); $store.commit('setBigMap', true)" class="link flex items-center mb-8">
         <i class="material-icons">arrow_back</i>
         <label>{{ $t('volver') }}</label>
      </button>
    </div>
<div id="fondo">
<div class="frame">
	<div id="responsive1">
		<h2>Sobre Árbola</h2>
		<p>ÁRBOLA es la primera aplicación web de reforestación y conservación de biodiversidad. Crea tu perfil con nombre y foto para donar semillas, las que podrás plantar en el lugar que más te guste. Al momento de plantar una semilla, escoges la especie y el lugar donde la quieres plantar. Con ÁRBOLA, puedes apadrinar un árbol endémico o nativo en los ecosistemas más biodiversos del planeta.</p>
		<p>Los árboles apadrinados ya se encuentran plantados. Cada donación cubre la instalación de viveros, el cercado, el proceso de reforestación y el mantenimiento durante 3 años para cada árbol apadrinado. Además de eso, ÁRBOLA proporciona un vínculo directo entre el donante y el proyecto de reforestación. La app se lanzó en mayo de 2019, por lo que agradecemos cada donación.</p>
	</div>        
	<div class="responsive2">	
		<iframe id="video" width="100%" height="100%" src="https://www.youtube.com/embed/9egA4nTzgqg?&hl=es-419&cc_lang_pref=es-419&cc_load_policy=1" frameborder="0" allowfullscreen></iframe>
	</div>
</div>

<div class="frame">
	<div id="titulo">
		<h3>Sobre la Fundación Red Forestal</h3>
	</div>
	<div class="responsive2">
		<img id="imagen" src="@/assets/imgabout/imagen1.jpg">
	</div>	
	<div id="responsive3">	
		<p>La Fundación Red Forestal es una organización sin fines de lucro establecida en el año 2018 en el Ecuador, nuestro objetivo es desarrollar proyectos de reforestación y conservación de la biodiversidad. </p>
		<p>Promovemos la protección de la naturaleza usando las nuevas tecnologías de comunicación, creando redes de cooperación y generado conciencia ambiental. Trabajamos en conjunto con otras organizaciones sin fines de lucro, enfocados en el objetivo común de la conservación medioambiental, la mitigación del cambio climático, la provisión de servicios ecosistémicos y la protección de espacios de vida. Contribuimos al desarrollo y mantenimiento de reservas ecológicas y corredores de conectividad biológica en el Ecuador. Protegiendo y expandiendo así los hábitats de las especies de flora y fauna que se encuentran en peligro y habitan en estos territorios.</p>
		<div id="hidden1">
			<center>
				<img id="logo1" src="@/assets/imgabout/logoFundacion.jpg">
				<p class="dudas">Si tienes dudas o inquitudes escríbenos un correo electrónico a:<br><a href="mailto:contacto@plantavida.app">contacto@plantavida.app</a>.</p>
				<p><a href="http://redforestal.org">Visita la página web de la Fundación Red Forestal.</a></p>
			</center>
		</div>
	</div>
</div>
<div id="hidden2">
	<center>
		<img id="logo2" src="@/assets/imgabout/logoFundacion.jpg">
		<p class="dudas">Si tienes dudas o inquitudes escríbenos un correo electrónico a:<br><a href="mailto:contacto@plantavida.app">contacto@plantavida.app</a>.</p>
		<p><a href="http://redforestal.org" target="_blank">Visita la página web de la Fundación Red Forestal.</a></p>
	</center>
</div>
</div>
  </bvue-ui-view>
</template>

<script>
export default {
  name: 'About',
  mounted() {
    this.$ga.page('/Sobre Nosotros ES');
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
@import '@/style/aboutresponsive.scss';

</style>


// WEBPACK FOOTER //
// src/pages/About.vue